// @ts-nocheck
import {
  CFG,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SPELLS,
  SPELLS_IN_SLOT,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  EXPLOSION_BURN,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
} from "../../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../../util";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
} from "../../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../../audio";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../../lobby";

import { Game } from "../game-base";

Game.FW_EMBER_MAX = 36;

Game.FW_EMBER_RATE = 11;

Game.FW_FLAME_STEP = 20;

Game.FW_SPREAD_DUR = 0.42; // wall rips outward from cursor center

Game.prototype.fireWallSpread = function (w, t) {
    const hx = w.hx || 220;
    const born = w.born != null ? w.born : t;
    const prog = clamp((t - born) / Game.FW_SPREAD_DUR, 0, 1);
    const eased = prog * prog * (3 - 2 * prog);
    return { prog, eased, visHx: hx * eased, hx };
  }

Game.prototype.fireWallEdgeFade = function (lx, hx) {
    const rim = hx * 0.14;
    const d = Math.abs(lx);
    if (d <= hx - rim) return 1;
    return clamp(1 - (d - (hx - rim)) / rim, 0, 1);
  }

Game.prototype.fireWallAng = function (w) {
    return (w.dx || w.dy) ? Math.atan2(w.dy, w.dx) : 0;
  }

Game.prototype.fireWallPoint = function (w, lx) {
    const a = this.fireWallAng(w);
    return { x: w.x + lx * Math.cos(a), y: w.y + lx * Math.sin(a) };
  }

Game.prototype.updateFireWallEmbers = function (dt) {
    this.updateFirewallBurnTrail();
    const active = this.state === "playing" || this.state === "countdown";
    const cap = Game.FW_EMBER_MAX;
    const t = this.nowS;
    for (const w of this.firewalls) {
      if (!w.emberParts) w.emberParts = [];
      const hx = w.hx || 220, hy = w.hy || 24;
      const { visHx, prog } = this.fireWallSpread(w, t);
      const fade = w.life != null ? Math.min(1, w.life / 0.6) : 1;
      if (!active || fade <= 0 || prog < 0.12) continue;

      w._emberAcc = (w._emberAcc || 0) + dt * Game.FW_EMBER_RATE * fade * clamp(prog * 2.2, 0.25, 1);
      while (w._emberAcc >= 1 && w.emberParts.length < cap) {
        w._emberAcc -= 1;
        const lx = rand(-visHx * 0.88, visHx * 0.88);
        if (this.fireWallEdgeFade(lx, visHx) < 0.08) continue;
        w.emberParts.push({
          lx,
          rise: rand(0, hy * 0.45),
          drift: rand(-10, 10),
          riseV: rand(70, 130),
          life: rand(0.28, 0.55), maxLife: 0.55,
          size: rand(2.5, 5),
          col: Math.random() < 0.55 ? "#ffd479" : "#ff7a2f",
          smoke: Math.random() < 0.22,
        });
      }
      compact(w.emberParts, p => {
        p.life -= dt;
        p.lx += p.drift * dt;
        p.rise += p.riseV * dt;
        return p.life > 0 && Math.abs(p.lx) < visHx * 1.06 && p.rise < hy * 6;
      });
    }
  }

/** Persistent scorch stamps along the wall as it rips outward (floorBurns layer). */
Game.prototype.updateFirewallBurnTrail = function () {
    const active = this.state === "playing" || this.state === "countdown" || this.state === "roundover";
    if (!active) return;
    const t = this.nowS;
    const cfg = EXPLOSION_BURN.firewall || EXPLOSION_BURN.projectile;
    const step = cfg.step || 36;
    for (const w of this.firewalls || []) {
      const { visHx, prog } = this.fireWallSpread(w, t);
      if (prog < 0.08 || visHx < 6) continue;
      if (!w._burnKeys) w._burnKeys = new Set();
      const maxLx = visHx * 0.94;
      for (let lx = 0; lx <= maxLx + 0.01; lx += step) {
        const sides = lx < 0.5 ? [0] : [-1, 1];
        for (const side of sides) {
          const key = lx < 0.5 ? "0" : `${side > 0 ? "+" : "-"}${Math.round(lx)}`;
          if (w._burnKeys.has(key)) continue;
          w._burnKeys.add(key);
          const pt = this.fireWallPoint(w, side * lx);
          this.spawnFloorBurn("firewall", pt.x, pt.y, null, { rot: rand(0, TAU) });
        }
      }
    }
  }

Game.prototype.drawFireWallEmber = function (c, w, p, visHx, fade) {
    const edge = this.fireWallEdgeFade(p.lx, visHx);
    const a = clamp(p.life / (p.maxLife || 1), 0, 1) * fade * edge;
    if (a < 0.04) return;
    const born = Math.sin(clamp(1 - p.life / (p.maxLife || 1), 0, 1) * Math.PI);
    const pt = this.fireWallPoint(w, p.lx);
    c.save();
    c.translate(pt.x, pt.y - p.rise);
    if (p.smoke) {
      c.globalAlpha = a * 0.35 * born;
      c.fillStyle = "#2a2018";
      const r = p.size * (1 + (1 - a) * 1.2);
      c.beginPath(); c.arc(0, 0, r, 0, TAU); c.fill();
    } else {
      c.globalCompositeOperation = "lighter";
      c.globalAlpha = a * 0.5;
      c.fillStyle = p.col;
      c.beginPath(); c.arc(0, 0, p.size * 1.35, 0, TAU); c.fill();
      c.globalAlpha = a * 0.85;
      c.beginPath(); c.arc(0, 0, p.size * 0.65, 0, TAU); c.fill();
    }
    c.restore();
  }

Game.prototype.drawFireWallRip = function (c, visHx, hy, spread, fade, pulse, t) {
    const { prog, eased } = spread;
    if (prog >= 1 || visHx < 2) return;
    c.save();

    // impact flash at cursor when the rip starts
    if (prog < 0.4) {
      const burst = 1 - prog / 0.4;
      c.globalCompositeOperation = "lighter";
      c.globalAlpha = fade * burst * (0.45 + 0.35 * pulse);
      const g = c.createRadialGradient(0, hy * 0.1, 0, 0, 0, hy * (2.2 + burst * 3));
      g.addColorStop(0, "rgba(255,240,200,0.75)");
      g.addColorStop(0.35, "rgba(255,120,40,0.35)");
      g.addColorStop(1, "rgba(0,0,0,0)");
      c.fillStyle = g;
      c.beginPath(); c.ellipse(0, hy * 0.08, hy * (0.9 + burst), hy * (0.55 + burst * 0.4), 0, 0, TAU); c.fill();
    }

    const segs = 10;
    for (const side of [-1, 1]) {
      // dark fissure
      c.beginPath();
      c.moveTo(0, hy * 0.12);
      for (let i = 1; i <= segs; i++) {
        const f = i / segs;
        const x = side * visHx * f;
        const jag = Math.sin(t * 22 + side * i * 1.9 + f * 8.5) * hy * 0.28 * (1 - f * 0.45);
        const lift = -hy * 0.08 * f * eased;
        c.lineTo(x, jag + lift);
      }
      c.strokeStyle = `rgba(12,6,4,${0.92 * fade})`;
      c.lineWidth = 3.5 + eased * 1.5;
      c.lineCap = "round";
      c.lineJoin = "round";
      c.stroke();

      // leading edge — ground chunk lifting at the rip front
      const edgeX = side * visHx;
      const lip = 0.55 + 0.45 * Math.sin(t * 14 + side * 3);
      c.globalAlpha = fade * lip * (0.5 + 0.4 * eased);
      const eg = c.createLinearGradient(edgeX - side * 10, 0, edgeX + side * 18, 0);
      eg.addColorStop(0, "rgba(255,200,120,0)");
      eg.addColorStop(0.5, "rgba(255,160,60,0.7)");
      eg.addColorStop(1, "rgba(80,30,10,0)");
      c.fillStyle = eg;
      c.beginPath();
      c.moveTo(edgeX, hy * 0.55);
      c.lineTo(edgeX + side * 14, -hy * 0.35);
      c.lineTo(edgeX + side * 6, -hy * 0.9);
      c.lineTo(edgeX - side * 4, hy * 0.2);
      c.closePath();
      c.fill();
    }
    c.restore();
  }

Game.prototype.drawFireWallGround = function (c, visHx, hy, col, fade, pulse, t) {
    c.save();
    // faint live glow while flames are up — persistent char is on floorBurns
    c.fillStyle = `rgba(18,10,8,${0.18 * fade})`;
    c.beginPath();
    c.ellipse(0, hy * 0.15, visHx * 0.98, hy * 1.15, 0, 0, TAU);
    c.fill();

    c.globalCompositeOperation = "lighter";
    // continuous burning bed along the full rift
    const along = c.createLinearGradient(-visHx, 0, visHx, 0);
    along.addColorStop(0, "rgba(0,0,0,0)");
    along.addColorStop(0.07, rgba(col, 0.14 * fade));
    along.addColorStop(0.5, rgba(col, (0.42 + 0.14 * pulse) * fade));
    along.addColorStop(0.93, rgba(col, 0.14 * fade));
    along.addColorStop(1, "rgba(0,0,0,0)");
    c.fillStyle = along;
    c.fillRect(-visHx, -hy * 0.45, visHx * 2, hy * 1.05);

    const cross = c.createLinearGradient(0, -hy * 0.5, 0, hy * 0.55);
    cross.addColorStop(0, "rgba(255,80,20,0)");
    cross.addColorStop(0.45, rgba(col, (0.22 + 0.08 * pulse) * fade));
    cross.addColorStop(1, "rgba(255,60,10,0)");
    c.fillStyle = cross;
    c.fillRect(-visHx, -hy * 0.5, visHx * 2, hy * 1.05);
    c.restore();
  }

Game.prototype.drawFireWallHeat = function (c, visHx, hy, col, fade, pulse, t) {
    c.save();
    c.globalCompositeOperation = "lighter";
    c.globalAlpha = fade * (0.08 + 0.05 * pulse);
    const g = c.createLinearGradient(-visHx, -hy * 1.6, -visHx, -hy * 3.2);
    g.addColorStop(0, rgba(col, 0.22));
    g.addColorStop(0.55, "rgba(255,220,160,0.08)");
    g.addColorStop(1, "rgba(0,0,0,0)");
    c.fillStyle = g;
    c.fillRect(-visHx, -hy * 3.2, visHx * 2, hy * 1.7);
    c.restore();
  }

// Build the flame body gradient once per wall (colors depend only on the
// per-wall fade/pulse). Defined in unit height [0,-1] so every flame segment can
// reuse it under a per-segment scale() instead of allocating a gradient each.
Game.prototype.fireWallBodyGrad = function (c, fade, pulse) {
    const body = c.createLinearGradient(0, 0, 0, -1);
    body.addColorStop(0, `rgba(220,55,10,${fade * (0.48 + 0.1 * pulse)})`);
    body.addColorStop(0.42, `rgba(255,120,30,${fade * (0.4 + 0.08 * pulse)})`);
    body.addColorStop(0.74, `rgba(255,200,100,${fade * (0.26 + 0.07 * pulse)})`);
    body.addColorStop(1, "rgba(255,240,200,0)");
    return body;
  }

// Drawn in world space — negative Y is always screen-up, regardless of wall angle.
// `bodyGrad` is the shared per-wall gradient from fireWallBodyGrad (unit height).
Game.prototype.drawFireWallFlame = function (c, hy, fade, pulse, t, seed, bodyGrad) {
    const flick = 0.5 + 0.5 * Math.sin(t * 11 + seed);
    const sway = Math.sin(t * 4.2 + seed * 0.7) * 3.5;
    const h = hy * (2.05 + 0.5 * flick) * fade * (0.86 + 0.14 * Math.sin(seed * 0.19));
    const w = 4.5 + flick * 3;

    c.save();
    c.translate(sway, hy * 0.06);
    c.globalCompositeOperation = "lighter";
    // Unit space: x in [-1,1], y in [0,-1]; scale maps it to the flame's w/h.
    // The shared gradient (0,0)→(0,-1) stretches to (0,0)→(0,-h) under this CTM.
    c.scale(w, h);

    c.fillStyle = bodyGrad;
    c.beginPath();
    c.moveTo(-1, 0);
    c.quadraticCurveTo(-0.32, -0.6, 0, -1);
    c.quadraticCurveTo(0.32, -0.6, 1, 0);
    c.closePath();
    c.fill();

    c.globalAlpha = fade * (0.5 + 0.18 * pulse);
    c.fillStyle = "rgba(255,230,160,0.72)";
    c.beginPath();
    c.moveTo(-0.26, 0);
    c.quadraticCurveTo(0, -0.56, 0.26, 0);
    c.closePath();
    c.fill();

    c.restore();
  }

Game.prototype.drawFireWalls = function () {
    const c = this.ctx;
    const t = this.nowS;
    const col = (SPELLS.firewall || {}).color || "#ff7a2f";
    const wallFX = [];

    // Ground/scorch follows the wall orientation; flames and embers stay world-up.
    for (const w of this.firewalls) {
      const hy = w.hy || 24;
      const spread = this.fireWallSpread(w, t);
      const { visHx, prog } = spread;
      const fade = w.life != null ? Math.min(1, w.life / 0.6) : 1;
      const pulse = 0.5 + 0.5 * Math.sin(t * 8 + (w.pulse || 0));
      const ang = this.fireWallAng(w);
      c.save();
      c.translate(w.x, w.y);
      c.rotate(ang);

      this.drawFireWallRip(c, visHx, hy, spread, fade, pulse, t);
      this.drawFireWallGround(c, visHx, hy, col, fade, pulse, t);
      if (prog > 0.2) {
        this.drawFireWallHeat(c, visHx, hy, col, fade * clamp((prog - 0.2) / 0.5, 0, 1), pulse, t);
      }
      c.restore();

      wallFX.push({ w, hy, visHx, prog, fade, pulse, col });
    }

    for (const fx of wallFX) {
      const { w, hy, visHx, prog, fade, pulse } = fx;
      const flameFade = clamp(prog * 1.35, 0, 1);
      const seedOff = w.pulse || 0;
      const step = this.firewalls.length > 2 ? Game.FW_FLAME_STEP * 1.5 : Game.FW_FLAME_STEP;
      // Gradient colors depend only on the per-wall flameFade/pulse — build once
      // and reuse across every flame segment instead of allocating one each.
      const bodyGrad = this.fireWallBodyGrad(c, flameFade, pulse);
      for (let lx = -visHx + step * 0.5; lx <= visHx; lx += step) {
        const edge = this.fireWallEdgeFade(lx, visHx);
        if (edge < 0.05) continue;
        const jitter = Math.sin(lx * 0.073 + seedOff) * step * 0.2;
        const pt = this.fireWallPoint(w, lx + jitter);
        c.save();
        c.translate(pt.x, pt.y);
        c.globalAlpha = edge * fade * flameFade;
        this.drawFireWallFlame(c, hy, flameFade, pulse, t, lx * 12.9898 + seedOff, bodyGrad);
        c.restore();
      }
      c.globalAlpha = 1;
      for (const p of (w.emberParts || [])) {
        this.drawFireWallEmber(c, w, p, visHx, fade);
      }
    }

    c.globalCompositeOperation = "source-over";
    c.globalAlpha = 1;
    c.shadowBlur = 0;
  }
